import { styled } from '@linaria/react';
import { breakpoints, layout, semantic, space } from '../../theme/tokens';

export const TopBarSlot = styled.div`
  position: sticky;
  top: var(--announcement-banner-height, 0px);
  z-index: 50;
  width: 100%;
  box-sizing: border-box;
  background: ${semantic.bg.canvas};
  padding: ${space['space-800']} ${space['space-600']} 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-1000']} ${space['space-1000']} 0;
  }
`;

export const HeadingArea = styled.div`
  padding: 0 0 ${space['space-1000']};

  & h1 {
    max-width: 12.5em;
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-top: ${space['space-500']};
    text-align: center;

    & h1 {
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding-right: ${space['space-1200']};
    padding-left: ${space['space-1200']};
  }
`;

export const GridArea = styled.div`
  @media (min-width: ${breakpoints.desktop}) {
    padding: 0
      clamp(
        0px,
        calc((100vw - ${breakpoints.desktop}) * 0.6),
        calc(${space['space-2000']} + ${space['space-1200']})
      );
  }
`;
